
function Erro(){
    return(
        <div className='erro'>
            <img src="https://webinsider.com.br/wp-content/uploads/2019/01/Erro-404-1-1-1024x645.jpg"></img>
        </div>
    )
}

export default Erro;